import stateMessages from './messages'


export type StateMessages  = typeof stateMessages
export type StateShortName = keyof StateMessages
export type StatesInObject = { [key in StateShortName]: string | StateMessages[key] }

// Pass on "intl" object if you need string type in title

// return => [ { value: 'AK', title: 'Alaska' / intl message } ]
const getUsaStatesInArray = (intl?: ReactIntl) => (
  Object.keys(stateMessages).map((state: StateShortName) => ({
    value: state,
    title: intl ? intl.formatMessage(stateMessages[state]) : stateMessages[state],
  }))
)

// return => [ { value: 'AK', title: 'AK' } ]
const getShortUsaStatesInArray = () => (
  Object.keys(stateMessages).map((state: StateShortName) => ({
    value: state,
    title: state,
  }))
)

// return => [ { value: 'AK', title: 'AK' } ] without restricted military states
const getShortUsaStatesForShippingInArray = () => {
  const excludedStates = [ 'AA', 'AE', 'AP' ]

  return getShortUsaStatesInArray()
    .filter(({ value }) => !excludedStates.includes(value))
}

// return => { AK: 'Alaska' / intl message }
const getUsaStatesInObject = (intl?: ReactIntl): StatesInObject => {
  const states = {}

  Object.keys(stateMessages).forEach((state: StateShortName) => {
    states[state] = intl ? intl.formatMessage(stateMessages[state]) : stateMessages[state]
  })

  return states as StatesInObject
}


export {
  getUsaStatesInArray,
  getUsaStatesInObject,
  getShortUsaStatesInArray,
  getShortUsaStatesForShippingInArray,
}
